export const MAIN_VOD_THUMBNAIL = 'https://cdn.keycutstock.com/mp4/Artist%20Space%20thumb%20230801.png';
export const MAIN_VOD_URL = 'https://cdn.keycutstock.com/mp4/Artist%20Space%20Rolling%20230801.mp4';

export const BOTTOM_VOD_THUMBNAIL = 'https://cdn.keycutstock.com/mp4/Artist%20space%20bottom%20thumb.png';
export const BOTTOM_VOD_URL = 'https://cdn.keycutstock.com/mp4/Artist%20space%20bottom.mp4';

export const DASHBOARD_VOD_THUMBNAIL = 'https://cdn.keycutstock.com/mp4/FF11871.jpg';
export const DASHBOARD_VOD_URL = 'https://cdn.keycutstock.com/mp4/FF11871.mp4';

export const ACC_VERIFY_VOD_THUMBNAIL = 'https://cdn.keycutstock.com/mp4/FF07098.jpg';
export const ACC_VERIFY_VOD_URL = 'https://cdn.keycutstock.com/mp4/FF07098.mp4';

export const ACC_COMPLETE_VOD_THUMBNAIL = 'https://cdn.keycutstock.com/mp4/FF00938.jpg';
export const ACC_COMPLETE_VOD_URL = 'https://cdn.keycutstock.com/mp4/FF00938.mp4';

export const ACC_FINDPW_VOD_THUMBNAIL = 'https://cdn.keycutstock.com/mp4/FF11777.jpg';
export const ACC_FINDPW_VOD_URL = 'https://cdn.keycutstock.com/mp4/FF11777.mp4';

export const ACC_INPUTPW_VOD_THUMBNAIL = 'https://cdn.keycutstock.com/mp4/FF07060.jpg';
export const ACC_INPUTPW_VOD_URL = 'https://cdn.keycutstock.com/mp4/FF07060.mp4';

export const ACC_AGREE_VOD_THUMBNAIL = 'https://cdn.keycutstock.com/mp4/FF06555.jpg';
export const ACC_AGREE_VOD_URL = 'https://cdn.keycutstock.com/mp4/FF06555.mp4';
